export default __webpack_public_path__ + "media/zurb/img/home/come-in-three-4adb8a9deeb24dbb0e6b342596c39e1a.png";